import type { Option } from "ts-results-es";

export type Message = {
  id: Option<string>;

  // Just needs to be a soft link so we can grab a 'User' type if needed
  userId: number | null;

  // TODO: More types (e.g. text, image, video etc etc)
  message: string;

  side: MessageSide;

  title: string | null;
};

export enum MessageSide {
  left,
  right,
}

export interface SessionAlert {
  FlowGeneratorSessionId: number;
  AlertType: string;
}

export enum AlertTypes {
  ModelOutage = "Looks like the AI model is having outages (Type: ModelOutage)",
  ModelSafetyFilter = "External AI safety filter flagged a message (Type: ModelSafetyFilter)",
}
